import type { CupomItem } from "../models/cupomEstabelecimentoFornecedorModel"

export enum CupomEstabelecimentoFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR = "ADICIONAR",
    REMOVER = "REMOVER",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    CONFIRMAR_SAVE = "CONFIRMAR_SAVE",
}

export type CupomEstabelecimentoFornecedorActionModel =
    | {
          type: CupomEstabelecimentoFornecedorActionsTypes.CARREGAR
          payload: CupomItem[]
      }
    | {
          type: CupomEstabelecimentoFornecedorActionsTypes.ADICIONAR
      }
    | {
          type: CupomEstabelecimentoFornecedorActionsTypes.REMOVER
          payload: { localId: number; dbId: number | null }
      }
    | {
          type: CupomEstabelecimentoFornecedorActionsTypes.ATUALIZAR_CAMPO
          payload: { localId: number; campo: keyof CupomItem; valor: string | number | boolean | null }
      }
    | {
          type: CupomEstabelecimentoFornecedorActionsTypes.CONFIRMAR_SAVE
          payload: Array<{ id: number; cupomId: number }>
      }
